import { apiHelper } from "./core"

const clinicalServiceBaseUrl =
  process.env.REACT_APP_CLINICAL_MANAGEMENT_BASE_URL

const getMedicalRecordByAppointmentId = (
  appointmentId: string
): Promise<any> => {
  return apiHelper
    .get(`${clinicalServiceBaseUrl}/medicalrecords/${appointmentId}`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const getAllMedicalDetails = (
  appointmentId: string
): Promise<any> => {
  return apiHelper
    .get(`${clinicalServiceBaseUrl}/medicalrecords/${appointmentId}/all-medical-details`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const sendForApproval = (approvalReq: any): Promise<any> => {
  console.log("req", approvalReq)
  let approvalReqDetail: any = {
    rmoId: approvalReq?.rmoId,
    consultantId: approvalReq?.consultantId,
    patientId: approvalReq?.patientId,
    recordId: approvalReq?.recordId,
    centerId: approvalReq?.centerId,
    status: approvalReq?.status,
    approvalFor: approvalReq?.approvalFor,
    reason: approvalReq?.reason,
    appointmentDate: approvalReq?.appointmentDate
  }
  return apiHelper
    .post(`${clinicalServiceBaseUrl}/rmo-approval`, approvalReqDetail)
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const getRmoApprovalRequestDetails = (query: any): Promise<any> => {
  return apiHelper
    .get(`${clinicalServiceBaseUrl}/rmo-approval${query}`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}


//get Patient Information and Smart Summary
const searchByPatientName = (searchText: string): Promise<string> => {
  const patientName = searchText.trim()
  return apiHelper
    .get(`${clinicalServiceBaseUrl}/rmo-approval?patientName=${patientName}`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const sortByTime = (searchText: string): Promise<string> => {
  return apiHelper
    .get(`${clinicalServiceBaseUrl}/rmo-approval?sortBy=approvalRaisedTime`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const approveRejectPendingRequests = (
  approvalReq: any,
  Id: any
): Promise<any> => {
  console.log("req", approvalReq)
  let approvalReqDetail: any = {
    rmoId: approvalReq?.rmoId,
    consultantId: approvalReq?.consultantId,
    patientId: approvalReq?.patientId,
    recordId: approvalReq?.recordId,
    centerId: approvalReq?.centerId,
    status: approvalReq?.status,
    approvalFor: approvalReq?.approvalFor,
    reason: approvalReq?.reason,
    appointmentDate: approvalReq?.appointmentDate
  }
  return apiHelper
    .put(`${clinicalServiceBaseUrl}/rmo-approval/${Id}`, approvalReqDetail)
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const getPendingApprovalRequestById = (id: string): Promise<string> => {
  return apiHelper
    .get(`${clinicalServiceBaseUrl}/rmo-approval/${id}`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const getFollowUpDetails = (
  id: string,
  ignoreAutopopulatedFollowUp
:boolean = false): Promise<string> => {
  return apiHelper
    .get(
      `${clinicalServiceBaseUrl}/medicalrecords/${id}/follow-up-info${ignoreAutopopulatedFollowUp ? `?ignoreAutopopulatedFollowUp=${ignoreAutopopulatedFollowUp}` : ''}`
    )
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const getAllPreviousFollowUpDetails = (
  patientId: string,
  appointmentId: string
): Promise<string> => {
  return apiHelper
    .get(
      `${clinicalServiceBaseUrl}/medicalrecords/patient/${patientId}?appointmentId=${appointmentId}`
    )
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const getChemoOrderByAppointment = (id: string): Promise<string> => {
  return apiHelper
    // .get(`${clinicalServiceBaseUrl}/chemo-order/appointment?appointmentId=0B77C64C-ADDD-4376-BE38-E353B0DFDC53`)
    .get(`${clinicalServiceBaseUrl}/chemo-order/appointment?appointmentId=${id}`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}



export {
  getMedicalRecordByAppointmentId,
  getAllMedicalDetails,
  sendForApproval,
  getRmoApprovalRequestDetails,
  searchByPatientName,
  sortByTime,
  approveRejectPendingRequests,
  getPendingApprovalRequestById,
  getFollowUpDetails,
  getAllPreviousFollowUpDetails,
  getChemoOrderByAppointment
}
